import { Injectable } from '@angular/core';
import { Subscription } from '../../../node_modules/rxjs';
import { TranslateService } from '../../../node_modules/@ngx-translate/core';

@Injectable()
export class TranslationProvider {

  constructor(private translate: TranslateService) {

  }

  public getTranslations(translateObject: any, keys: Array<string>) {

    let instance = this;

    translateObject.translations = new Array<string>();
    translateObject.subscriptions = new Array<Subscription>();

    keys.forEach(function(key){

      let subscription = instance.translate.stream(key).subscribe(function(translation){

        translateObject.translations[key] = translation;

      });

      translateObject.subscriptions.push(subscription);

    });

  }

  public unsubscribeTranslations(translateObject: any) {

    translateObject.subscriptions.forEach(function(subscription){

      subscription.unsubscribe();
      
    });

  }

  public getCurrentLanguage() {

    return this.translate.currentLang;

  }

}



// WEBPACK FOOTER //
// ./src/providers/translation/translation.ts